import { render } from "./IconConsent.vue?vue&type=template&id=7f5a47b2&lang=html"
import script from "./IconConsent.vue?vue&type=script&lang=js"
export * from "./IconConsent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__